import request from './request';

export function searchPeople(attrs) {
  return request({
    path: `/v1/people/search`,
    type: 'post',
    json: attrs,
  });
}

export function findPerson(id) {
  return request({
    path: `/v1/people/${id}`,
    type: 'get',
  });
}

// People Columns

export function updatePersonColumns({ columns, segmentId }) {
  const path = segmentId
    ? `/v1/people/segments/${segmentId}/columns`
    : `/v1/people/columns`;

  return request({
    path,
    type: 'put',
    json: { columns },
  });
}

export function getAllPeopleColumns() {
  return request({
    path: `/v2/people/columns/all`,
  });
}

let peopleColumns = null;

export function getCachedAllPeopleColumns() {
  peopleColumns = peopleColumns || getAllPeopleColumns();
  return peopleColumns;
}
